import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { User } from '../project/project.model';


@Injectable()
export class UserService {

	constructor(
		private http: HttpClient
	) { }

	create(userObj: any, file: any): Observable<any> {
		let keys = Object.keys(userObj);
		let formData = new FormData();
		let temp = ['image', 'password_confirmation'];
		keys.forEach(key => {
			if (temp.indexOf(key) > -1) {
				console.log("key==========",key);
			} else {
				formData.append(key, userObj[key]);	
			}
		});
		if (file && file.name)
			formData.append('img_url', file);

		return this.http.post<any>(`${environment.resourceUrl}/users`, formData);
	}
	createByAdmin(userObj: any, file: any): Observable<any> {
		let keys = Object.keys(userObj);
		let formData = new FormData();
		let temp = ['image', 'password_confirmation'];
		keys.forEach(key => {
			if (temp.indexOf(key) > -1) {
				console.log("key==========",key);
			} else {
				formData.append(key, userObj[key]);	
			}
		});
		if (file && file.name)
			formData.append('img_url', file);

		return this.http.post<any>(`${environment.resourceUrl}/users/byadmin`, formData);
	}

	getAllUsers(): Observable<User[]> {
		return this.http.get<User[]>(`${environment.resourceUrl}/users/all`);
	}

	getRoles(): Observable<string[]> {
		return this.http.get<string[]>("api/iam/users/roles");
	}
}